<template>
  <PodiumCard title="Podium magasin" emoji="🏪" badge-class="bg-blue-50" :ranking="ranking" :show-amount="true" />
</template>

<script>
import PodiumCard from "./PodiumCard.vue";

export default {
  name: "RetributionsRanking",

  components: {
    PodiumCard,
  },

  props: {
    ranking: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
